import React from 'react'
import { LineShape, Point } from './expandGridCanvas.action'

export interface CanvasColours {
  primary: string
  onPrimary: string
  muted: string
  added: string
  addedSurface: string
  addedText: string
  removed: string
  surface: string
}

interface ExpandCanvasLineProps {
  // Where the line is in the drawing now, and where the expansion puts it.
  shape: LineShape
  start: Point
  anchor: Point
  replaced: boolean
  hovered: boolean
  opacity: number
  colour: CanvasColours
}

// One mooring line at the grown edge. Moved: a solid line to its new anchor. Replaced: a cross on the old anchor and a
// dashed new line. Hovered: thicker and larger, over a halo on the old line.
const ExpandCanvasLine: React.FC<ExpandCanvasLineProps> = ({
  shape,
  start,
  anchor,
  replaced,
  hovered,
  opacity,
  colour,
}) => {
  const width = hovered ? 7 : 3.5
  const radius = hovered ? 14 : 9
  const stroke = hovered ? 3.5 : 2.5
  return (
    <g opacity={opacity}>
      {hovered && (
        <line
          x1={shape.start.x}
          y1={shape.start.y}
          x2={shape.anchor.x}
          y2={shape.anchor.y}
          stroke={colour.muted}
          strokeWidth={9}
          strokeLinecap="round"
          opacity={0.75}
        />
      )}
      {replaced ? (
        <>
          <circle
            cx={shape.anchor.x}
            cy={shape.anchor.y}
            r={hovered ? 18 : 14}
            fill={colour.surface}
            stroke={colour.removed}
            strokeWidth={stroke}
          />
          <path
            d={`M${shape.anchor.x - 6} ${shape.anchor.y - 6}l12 12m0-12l-12 12`}
            stroke={colour.removed}
            strokeWidth={stroke}
          />
          <line
            x1={start.x}
            y1={start.y}
            x2={anchor.x}
            y2={anchor.y}
            stroke={colour.muted}
            strokeWidth={width}
            strokeDasharray="3 7"
            strokeLinecap="round"
          />
          <circle
            cx={anchor.x}
            cy={anchor.y}
            r={radius}
            fill={colour.surface}
            stroke={colour.muted}
            strokeWidth={2}
            strokeDasharray="4 3"
          />
        </>
      ) : (
        <>
          <line x1={start.x} y1={start.y} x2={anchor.x} y2={anchor.y} stroke={colour.added} strokeWidth={width} />
          <circle
            cx={anchor.x}
            cy={anchor.y}
            r={radius}
            fill={colour.addedSurface}
            stroke={colour.added}
            strokeWidth={stroke}
          />
        </>
      )}
    </g>
  )
}

export default ExpandCanvasLine
